export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS= 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const ME_START = 'ME_START';
export const ME_SUCCESS = 'ME_SUCCESS';
export const ME_FAIL = 'ME_FAIL';



// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js